import { useMemo } from "react";

// material-ui
// import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

// project import
import AppBarStyled from "./AppBarStyled";
import HeaderContent from "./HeaderContent";
import IconButton from "components/@extended/IconButton";

import useConfig from "hooks/useConfig";
// import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import {
  MenuOrientation,
  ThemeMode,
  DRAWER_WIDTH,
  MINI_DRAWER_WIDTH,
} from "config";

// assets
import MenuFoldOutlined from "@ant-design/icons/MenuFoldOutlined";
import MenuUnfoldOutlined from "@ant-design/icons/MenuUnfoldOutlined";
import { useDispatch, useSelector } from "react-redux";
import { menuAction } from "state/reducer/menu";

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

export default function Header() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  const { mode, menuOrientation } = useConfig();

  // const { menuMaster } = useGetMenuMaster();
  const { isDashboardDrawerOpened, isComponentDrawerOpened } = useSelector(
    (state) => state.menu,
  );
  const drawerOpen = isDashboardDrawerOpened;

  const dispatch = useDispatch();

  const isHorizontal =
    menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  // header content
  const headerContent = useMemo(() => <HeaderContent />, []);

  const iconBackColor =
    mode === ThemeMode.DARK ? "background.default" : "grey.100";

  // common header
  const mainHeader = (
    <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
      {!isHorizontal ? (
        <IconButton
          aria-label="open drawer"
          onClick={() =>
            dispatch(menuAction.setDashboardDrawerOpened(!drawerOpen))
          }
          edge="start"
          color="secondary"
          variant="light"
          sx={{
            color: "text.primary",
            bgcolor: drawerOpen ? "transparent" : iconBackColor,
            ml: { xs: 0, lg: -2 },
          }}
        >
          {!drawerOpen ? (
            <MenuUnfoldOutlined style={{ fontSize: "1rem" }} />
          ) : (
            <MenuFoldOutlined style={{ fontSize: "1rem" }} />
          )}
        </IconButton>
      ) : null}
      {headerContent}
    </Toolbar>
  );

  // app-bar params
  const appBar = {
    position: "fixed",
    color: "inherit",
    elevation: 0,
    sx: {
      borderBottom: "1px solid",
      borderBottomColor: "divider",
      zIndex: 1200,
      width: isHorizontal
        ? "100%"
        : {
            xs: "100%",
            lg: drawerOpen
              ? `calc(100% - ${DRAWER_WIDTH}px)`
              : `calc(100% - ${MINI_DRAWER_WIDTH}px)`,
          },
    },
  };

  return (
    <>
      {!downLG ? (
        <AppBarStyled open={drawerOpen} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  );
}
